import React from 'react'

import { Form, Col } from '_zari/core'

import { Select2Socios } from 'sharedComponents/select2'
import { ClearInputGroup } from 'sharedComponents/utils'

import * as SocioCrud from 'services/socio.service'

const SocioFormGroup = ({ iValue, iError, values, setValues }) => {
  const onChangeSocioHandler = pickedMember => {
    SocioCrud.obtenerInfoSocioxIdAsSlimSobrenombre(pickedMember.value).then(({ data }) => {
      values._idSocio = pickedMember.value
      values.documentoSocio = data.numeroDocumento
      values.nombreSocio = data.razonSocial
      values.sobrenombreSocio = data.sobrenombre

      setValues(values)
    })
  }

  const clickClear = () => {
    values._idSocio = ''
    values.nombreSocio = ''
    values.documentoSocio = ''
    values.sobrenombreSocio = ''
    values._idSocioSeguimiento = ''

    setValues(values)
  }

  return (
    <>
      <Form.Group>
        <Form.Label text='SOCIO' htmlFor='input-codigoRucSocio' md={2} alignRightAt='md' />
        <Col md={10}>
          {iValue ? (
            <ClearInputGroup id='input-codigoRucSocio' iValue={`${values.documentoSocio} - ${values.nombreSocio}`} clickClear={clickClear} />
          ) : (
            <Select2Socios id='codigoRucSelect' onChange={onChangeSocioHandler} />
          )}
          {iError && <Form.Feedback type='invalid'>{iError}</Form.Feedback>}
        </Col>
      </Form.Group>
    </>
  )
}

export default React.memo(SocioFormGroup)
